import { CardContent, CardHeader, Stack } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import MaterialTypography from "../../../components/MaterialTypography"
import MaterialButton from "../../../components/MaterialButton"
import { Add } from "@mui/icons-material"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { useSnackbar } from "../../../context/popup"
import { useLoading } from "../../../components/Loading"
import Table from "../../../components/Table"
import { useEffect, useState } from "react"
import { deleteData, fetchData } from "../../../services"
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index.js";

const WorkflowStepList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const currentPage = useSelector((state) => state?.operationWorkflowStepStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.operationWorkflowStepStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.operationWorkflowStepStore?.totalPages);

    const [workflowStepData, setWorkflowStepData] = useState([]);
    const [isRefresh, setIsRefresh] = useState(false);
    const [search, setSearch] = useState("");

    useEffect(() => {
        fetchWorkflowStepList();
    },[isRefresh, currentPage, rowsPerPage, search])

    //List API
    const fetchWorkflowStepList = async () => {
        setCircleLoading(true);
        try {
        const response = await fetchData(`/reference/orchestration/work-flow-steps?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`)        
        if(response?.success){
            setWorkflowStepData(response?.data?.items);
            dispatch(setTotalPages(response?.data?.totalPages));     
        }
        else{
            //throw error
            showSnackbar("Error Fetching Workflow List", "error")
        }
        } catch (error) {
            console.error('Error Fetching Insurer Api List:', error);
            showSnackbar(error?.message, "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        try {
            const response = await deleteData(`/orchestration/workflow-steps-delete`, {ids:[row?.id]});
            setIsRefresh(!isRefresh);
            if(response?.success){
                showSnackbar(response?.message, "success");
            }
            else{
                showSnackbar(response?.message, "error");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
            showSnackbar("Error deleting Insurer Registry data", "error");
        }
    };
    //table mapping
    const workflowBindingTable = {
        columns: [
            { key: "sno", label: "S.No.", renderCell: (row) => row.sno },            
            { key: "name", label: "Name", renderCell: (row) => row.name },
            { key: "label", label: "Label", renderCell: (row) => row.label },
            { key: "fieldCategory", label: "Field Category", renderCell: (row) => row.fieldCategory },
            {
            key: "isActive",
            label: "Status",
            renderCell: (row) => (
                <span>
                {row.isActive ? (
                    <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                ) : (
                    <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                )}
                </span>
            )
            },
        ],
        rows: workflowStepData?.map((item, index) => ({
            id: item?.id,
            sno: index + 1,
            name: item?.name || "",
            isActive: item?.isActive
        })),
    };
    
    const actions = {
        edit: true,
        view: true,
        delete: true,
    
        onEdit: (row) => {
            navigate(`/api-integration-engine/field-dictionary/field-dictionary-details?pageType=edit&id=${row.id}`);
        },
        onView: (row) => {
            navigate(`/api-integration-engine/field-dictionary/field-dictionary-details?pageType=view&id=${row.id}`);
        },
        onDelete: (row) => handleDelete(row),
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleSearch = (value) => {
        setSearch(value);
    };

  return (
    <DashboardLayout>
        <CardHeader title={(
            <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            >
                <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        Workflow Step List
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        List of Workflow Steps.
                    </MaterialTypography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        startIcon={<Add />}
                        onClick={() => navigate('/operation/workflow-step/workflow-step-details')}
                    >
                        Workflow Step
                    </MaterialButton>
                </Stack>
            </Stack>
            )} 
        />
        <CardContent>
          <Table
          columns={workflowBindingTable?.columns}
          data={workflowBindingTable?.rows}
          actions={actions}
          pagination={{
              totalPages,
              currentPage,
              onPageChange: (page) => handlePaginationChange(page),
              rowsPerPage,
              onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
              rowsPerPageOptions: [5, 10, 15, 20],
          }}
          getRowKey={(row) => row.id}
          className="custom-table"
          noDataLabel="No Workflow Step Data found"
          handleSearch={handleSearch}
          />
        </CardContent>
    </DashboardLayout>
  )
}

export default WorkflowStepList